/**
 * FERP Portal - Workflow List Page (DRR-074: Tabulator DRY Template)
 *
 * DESIGN Phase: Process templates governing patient care, financial approval, and compliance.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function WorkflowListPage() {
  return <TabulatorPrimitiveManager primitiveType="workflow" />;
}

export default WorkflowListPage;
